import type { FunctionalComponent, SVGAttributes } from 'vue'

export const AssetIcon = defineComponent({
  setup() {
    const getPath = (d: string, attrs?: SVGAttributes) => {
      return <path fill-rule="evenodd" clip-rule="evenodd" d={d} {...attrs} fill="var(--colors-primary)" />
    }

    return () => (
      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
        <ellipse opacity="0.398302" cx="11.1181" cy="6.87217" rx="6.00678" ry="5.99717" fill="var(--colors-primary)" />
        {getPath(
          'M7.39 11.5531C8.48307 12.4314 9.74111 12.8567 11.0155 12.8714C11.6445 12.8692 12.1402 12.8081 12.6284 12.6861C12.6683 12.6761 12.6883 12.6591 12.6989 12.6169C12.7819 12.288 12.8387 11.9547 12.8649 11.6168C12.9146 10.9755 12.8706 10.3405 12.7155 9.71538C12.3901 8.40361 11.7004 7.31947 10.6512 6.46799C9.68785 5.68623 8.58056 5.25242 7.34405 5.15295C6.68214 5.09973 6.028 5.15781 5.38376 5.32166C5.34623 5.33121 5.33195 5.34962 5.32274 5.38568C5.2376 5.71805 5.18091 6.05528 5.15492 6.39706C5.11045 6.98166 5.14277 7.56225 5.26964 8.13539C5.57648 9.52142 6.28343 10.664 7.39 11.5531ZM6.08771 17.0726C8.64152 17.4085 10.8953 16.1042 12.0037 14.2482C9.64399 14.4579 7.57998 13.7922 5.89706 12.1123C4.21348 10.4319 3.54461 8.3704 3.75687 6.01459C2.018 7.04035 0.531519 9.2771 0.944679 12.0414C1.32791 14.6054 3.39088 16.7179 6.08771 17.0726Z',
        )}
      </svg>
    )
  },
})

export const HeaderAssetIcon: FunctionalComponent<SVGAttributes> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M14.8577 3.43164V7.22435C14.8577 7.38142 14.9842 7.50593 15.1393 7.50593H18.7443C18.9895 7.50593 19.1159 7.21477 18.9512 7.03471C18.1065 6.12102 16.2312 4.12697 15.3385 3.23243C15.1604 3.05429 14.8577 3.17879 14.8577 3.43164ZM16.4923 13.3284H7.50347V11.8995H16.4923V13.3284ZM16.4923 16.9028H7.50347V15.4738H16.4923V16.9028ZM19.8572 8.9349H14.2441C13.7928 8.9349 13.4269 8.56899 13.4269 8.11761C13.4269 6.24531 13.4269 4.37301 13.4269 2.5007C10.6025 2.5007 7.77787 2.51069 4.95346 2.50282C4.50077 2.50155 4.13281 2.86796 4.13281 3.32065L4.13281 20.6827C4.13281 21.1341 4.49872 21.5 4.9501 21.5H19.0476C19.499 21.5 19.8649 21.1341 19.8649 20.6827V8.97129C19.863 8.95788 19.8611 8.94639 19.8572 8.9349Z"
        fill="var(--colors-bg-icon-primary)"
      />
    </svg>
  )
}
